import React, { memo } from "react";

import { Grid } from "@mui/material";

import { Title, Wrapper, WrapperComponentWithChild, ChildrenGrid } from "./styles";

type TitlePageProps = {
  title?: string;
  dataCy?: string;
  right?: React.ReactNode;
  left?: React.ReactNode;
  hasBoxShadow?: boolean;
  backgroundColor?: string;
  classNameTitle?: string;
  children?: React.ReactNode;
};

const TitlePage: React.FC<TitlePageProps> = ({
  backgroundColor,
  title,
  dataCy,
  right,
  left,
  classNameTitle,
  children,
  hasBoxShadow = true,
}) => {
  if (!title && !left && !right) return null;

  const returnDefaultComponent = () => (
    <Wrapper backgroundColor={backgroundColor} hasBoxShadow={hasBoxShadow}>
      {title && (
        <Title className={classNameTitle} data-cy={dataCy}>
          {title}
        </Title>
      )}
      {left}
      {right}
    </Wrapper>
  );

  const returnComponentWithChildren = () => (
    <WrapperComponentWithChild container direction="row">
      <Grid item xs={12}>
        {returnDefaultComponent()}
      </Grid>
      <ChildrenGrid item xs={12}>
        {children}
      </ChildrenGrid>
    </WrapperComponentWithChild>
  );

  return children ? returnComponentWithChildren() : returnDefaultComponent();
};

export default memo(TitlePage);
